module.exports = __webpack_public_path__ + "img/contacts.2210f6da.webp";